<template>
  <div class="staffhistoryDetail">
    <div class="subHead">
      <van-icon name="arrow-left" class="arrow" @click="goBack" />
      <span class="subHead-text">{{ subHead }}</span>
    </div>
    <div
      v-if="activeName === 'MY_ATTEND'"
      class="visitStatusBox"
      :style="`background-color: ${historyDetail.signStatus ? zh.zhCN.signStatus[historyDetail.signStatus][1] : ''}`"
    >
      {{ historyDetail.signStatus ? zh.zhCN.signStatus[historyDetail.signStatus][0] : '' }}
    </div>
    <div
      v-else
      class="visitStatusBox"
      :style="`background-color: ${historyDetail.meetingStatus ? zh.zhCN.meetingStatus[historyDetail.meetingStatus][1] : ''}`"
    >
      {{ historyDetail.meetingStatus ? zh.zhCN.meetingStatus[historyDetail.meetingStatus][0] : '' }}
    </div>
    <div class="content">
      <p class="content-title">{{ contentTitleOne }}</p>
      <div class="signIn">
        <svg-icon v-if="historyDetail.signIn" icon-class="sign_in" style="font-size: 0.8rem" />
      </div>
      <van-cell title="会议主题">
        <template #right-icon>
          {{ historyDetail.theme }}
        </template>
      </van-cell>
      <van-cell title="开始时间">
        <template #right-icon>
          {{ historyDetail.startTime }}
        </template>
      </van-cell>
      <van-cell title="结束时间">
        <template #right-icon>
          {{ historyDetail.endTime }}
        </template>
      </van-cell>
      <van-cell title="会议类型">
        <template #right-icon>
          {{ historyDetail.meetingTypeName }}
        </template>
      </van-cell>
      <van-cell title="联系人">
        <template #right-icon>
          {{ historyDetail.organizer }}
        </template>
      </van-cell>
      <van-cell title="参会人" @click="onAttendees">
        <template #right-icon>
          <span style="display: flex; align-items: center">
            {{ historyDetail.attendeesLength }}
            <van-icon name="arrow" class="search-icon" />
          </span>
        </template>
      </van-cell>
      <van-cell v-if="historyDetail.meetingType === 'PUBLIC'" title="人数上限">
        <template #right-icon>
          <span>
            {{ historyDetail.outsizeAttendeeCount }}
          </span>
        </template>
      </van-cell>
      <van-cell v-if="historyDetail.meetingType === 'PUBLIC'" title="主办方">
        <template #right-icon>
          <span>
            {{ historyDetail.organization }}
          </span>
        </template>
      </van-cell>
      <van-cell v-if="historyDetail.meetingType === 'PUBLIC'" title="协办方">
        <template #right-icon>
          <span>
            {{ historyDetail.coOrganization || '无' }}
          </span>
        </template>
      </van-cell>
      <van-cell title="会务要求" @click="onRequires">
        <template #right-icon>
          <van-icon v-if="historyDetail.requires.length > 0" name="arrow" class="search-icon" />
          <span v-else>无</span>
        </template>
      </van-cell>
      <div class="itemClass">
        <div class="meetingItem">
          <div>会议内容</div>
          <div style="word-break: break-all; word-wrap: break-word;">{{ historyDetail.meetingContent || '无' }}</div>
        </div>
      </div>
      <div class="itemClass">
        <div class="meetingItem">
          <div>会议议程</div>
          <div>
            {{ historyDetail.agendasStr || '无' }}
          </div>
        </div>
      </div>
    </div>
    <div v-if="historyDetail.materials && historyDetail.materials.length > 0" class="content">
      <p class="content-title">会议资料
        <span style="color: #969799">（请复制链接在浏览器中下载）</span>
      </p>
      <van-cell-group>
        <van-cell v-for="(item, index) in historyDetail.materials" :key="index" :title="filterTitle(item.materialName)">
          <template #right-icon>
            <van-icon name="description" color="#3b86ff" class="tag" @click="() => onCopy(item.materialUrl)" />
          </template>
        </van-cell>
      </van-cell-group>
    </div>
    <div class="content">
      <p class="content-title">{{ contentTitleTwo }}</p>
      <van-cell title="签到规则">
        <template #right-icon>
          {{ historyDetail.signTypeName }}
        </template>
      </van-cell>
      <van-cell :title="`会议前${historyDetail.signTime}分钟开始签到`" />
    </div>
    <div v-if="filterShare() && showShareBtn && historyDetail.meetingType === 'PUBLIC'" class="content">
      <p class="content-title">会议邀请</p>
      <van-cell title="邀请函">
        <template #right-icon>
          <div>
            <svg-icon icon-class="share_wechat" class-name="inviteWechatShare" @click="onShare" />
            <span class="url" @click="onCopyShareUrl">
              <svg-icon icon-class="share_copy" class-name="inviteCopyShare" />
            </span>
          </div>
        </template>
      </van-cell>
    </div>
    <div class="content">
      <p class="content-title">{{ contentTitleThree }}</p>
      <van-steps direction="vertical" :active="historyDetail.statesLength - 1">
        <van-step v-for="son in historyDetail.states">
          <div>{{ son.remark }}</div>
          <p>{{ son.createTime }}</p>
        </van-step>
      </van-steps>
    </div>
    <div v-if="filterCheck(historyDetail.audit)" class="btns">
      <div style="margin-right: 0.1rem" @click="refuseCheck">拒绝</div>
      <div @click="passCheck">通过</div>
    </div>
    <div class="btns">
      <div v-if="filterShowPass(historyDetail.meetingStatus, historyDetail.visitorLogId)" :style="filterSign(historyDetail.meetingStatus, historyDetail.signIn) ? 'margin-right: 0.1rem; background: #FFBE00;' : 'background: #FFBE00;'" @click="getCode">通行凭证</div>
      <div v-if="filterSign(historyDetail.meetingStatus, historyDetail.signIn)" style="background: #2DCC2C;" @click="meetingSignIn">
        <div>
          签到
        </div>
      </div>
    </div>
    <div v-if="filterJoin(historyDetail)" class="btns" @click="onCancelJoin">
      <div style="background-color: #3b86ff;">
        取消参会
      </div>
    </div>
    <div v-if="filterCancelMeeting(historyDetail)" class="btns" @click="onCancel">
      <div style="background-color: #3b86ff;">
        取消会议
      </div>
    </div>
    <div v-if="filterReBook(historyDetail)" class="btns" @click="onRebook">
      <div style="background-color: #3b86ff;">
        重新预约
      </div>
    </div>
    <van-dialog v-model="showRefuseDialog" title="温馨提示" show-cancel-button @confirm="confirmRefuse">
      <van-cell-group>
        <van-field v-model="message" class="control" rows="1" autosize type="textarea" placeholder="请输入拒绝原因" />
      </van-cell-group>
    </van-dialog>
    <van-overlay :show="showTips" @click="showTips = false">
      <div class="cover" @click.stop>
        <svg-icon icon-class="share" class-name="share" />
        <svg-icon icon-class="share_btn" class-name="shareBtn" @click="showTips = false" />
      </div>
    </van-overlay>
    <van-dialog
      v-model="showCancelDialog"
      title="温馨提示"
      show-cancel-button
      @confirm="confirmCancel"
    >
      <van-cell-group>
        <van-field v-model="messageCancel" class="control" rows="1" autosize type="textarea" placeholder="请输入取消原因" />
      </van-cell-group>
    </van-dialog>
    <van-dialog
      v-model="showMeetingCancelDialog"
      title="温馨提示"
      show-cancel-button
      @confirm="confirmMeetingCancel"
    >
      <van-cell-group>
        <van-field v-model="meetingMessageCancel" class="control" rows="1" autosize type="textarea" placeholder="请输入取消原因" />
      </van-cell-group>
    </van-dialog>
  </div>
</template>

<script>
import {
  meetingCancel,
  meetingInfo,
  meetingInfoBrowser,
  meetingAudit,
  meetingSignIn,
  meetingSignInBrowser,
  meetingShare,
  meetingAttendeeCancel,
  meetingAttendeeCancelBrowser
} from '@/api/user';
import Clipboard from 'clipboard';
import { Step, Steps } from 'vant';
import config from '@/common/config';
import { wechatSignature } from '@/api/home';
import wx from 'weixin-js-sdk';
export default {
  name: 'StaffMeetingHistoryDetail',
  components: {
    [Steps.name]: Steps,
    [Step.name]: Step
  },
  data() {
    return {
      activeName: this.$route.params.activeName,
      subHead: '详情',
      headName: '',
      color: '',
      personalInfo: {},
      contentTitleOne: '会议信息',
      contentTitleTwo: '会议规则',
      contentTitleThree: '会议动态',
      visitStatus: '访问中',
      showRefuseDialog: false,
      showTips: false,
      showShareBtn: false,
      showCancelDialog: false,
      showMeetingCancelDialog: false,
      message: '',
      meetingMessageCancel: '',
      messageCancel: '',
      historyDetail: {
        signTime: 0,
        signStatus: '',
        requires: []
      },
      acpyVisitorsArr: [
        {
          name: '张大大',
          phone: '13507245734',
          carNumber: '',
          status: 'CANCEL'
        },
        {
          name: '张大大',
          phone: '13507245734',
          carNumber: '粤AC527',
          status: 'WAITING_VISIT'
        },
        {
          name: '张大大',
          phone: '13507245734',
          status: 'FINISH',
          carNumber: ''

        }
      ],
      statusMap: {
        CANCEL: ['已取消', '#919191'],
        AUDITING: ['待审核', '#F76260'],
        AUDIT_OUTTIME: ['超时未审核', '#F2B230'],
        AUDIT_FAIL: ['未过审', '#333333'],
        BE_START: ['待开始', '#F2B230'],
        MEETING: ['会议中', '#3B86FF'],
        FINISH: ['已完成', '#2DCC2C']
      },
      weChatEve: true
    };
  },
  created() {
    const ua = window.navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) != 'micromessenger') {
      this.weChatEve = false;
    }
    this.personalInfo = JSON.parse(localStorage.getItem('personalInfo') || '{}');
    this.getHistoryDetail();
  },
  methods: {
    filterCheck(val) {
      if (val && val.operate && this.$route.params.activeName === 'MY_AUDIT') {
        return true;
      } else {
        return false;
      }
    },
    filterSign(val, signIn) { // 我枯了
      if (this.historyDetail.apply && this.$route.params.activeName === 'MY_ATTEND') {
        if (this.historyDetail.signType !== 'ACCESS_AUTOMATIC_SIGN') { // 门禁签到的时候不用手动签到
          if (val === 'BE_START' || val === 'MEETING') {
            if (signIn !== null) {
              return !signIn;
            } else {
              return false;
            }
          } else {
            return false;
          }
        }
        return false;
      } else {
        return false;
      }
    },
    filterShowPass(val, id) {
      if ((val === 'BE_START' || val === 'MEETING') && id > 0 && (this.$route.params.activeName === 'MY_ATTEND') && this.weChatEve) {
        return true;
      } else {
        return false;
      }
    },
    filterJoin(historyDetail) {
      // signStatus
      const list = [
        'BE_START',
        'MEETING'
      ];
      if (historyDetail.signStatus !== 'CANCEL' && historyDetail.cancelAttendee && !historyDetail.signIn && list.includes(historyDetail.meetingStatus) && this.$route.params.activeName === 'MY_ATTEND') {
        return true;
      } else {
        return false;
      }
    },
    filterCancelMeeting(historyDetail) {
      if (historyDetail.operateCancel && this.$route.params.activeName === 'MY_CREATE') {
        return true;
      } else {
        return false;
      }
    },
    filterReBook(historyDetail) {
      const list = [
        'FINISH',
        'CANCEL',
        'AUDIT_OUTTIME',
        'AUDIT_FAIL'
      ];
      if (this.personalInfo.staff && historyDetail.mineCreate && list.includes(historyDetail.meetingStatus) && this.$route.params.activeName === 'MY_CREATE') {
        return true;
      } else {
        return false;
      }
    },
    filterTitle(name) {
      if (name.length > 15) {
        return name.substring(0, 15) + '...' + name.substring(name.lastIndexOf('.') + 1);
      } else {
        return name;
      }
    },
    goBack() {
      if (this.weChatEve) {
        this.$router.push({ name: 'staffMeetingHistory' });
      } else {
        this.$router.go(-1);
      }
    },
    filterShare() {
      const { meetingStatus } = this.historyDetail;
      if (meetingStatus === 'BE_START' && this.weChatEve) {
        meetingShare({ id: this.$route.params.id }).then(res => {
          if (res.data.done && res.data.share) {
            this.inviteUrl = res.data.url;
            this.showShareBtn = true;
          }
        });
        return true;
      } else {
        return false;
      }
    },
    getHistoryDetail() {
      if (!this.weChatEve) {
        const str = this.$route.params.id.split('-');
        meetingInfoBrowser({ meetingId: str[0], phone: str[1] }).then(response => {
          this.historyDetail = response.data;
          this.historyDetail.attendeesLength = response.data.attendees ? `${response.data.attendees.length}人` : '0人';
          this.historyDetail.statesLength = response.data.states ? response.data.states.length : 0; 4;
          let data = '';
          if (response.data.agendas) {
            data = response.data.agendas.join('、');
          } else {
            data = '无';
          }
          this.historyDetail.agendasStr = data;
          this.headName = this.statusMap[response.data.meetingStatus][0];
          this.color = this.statusMap[response.data.meetingStatus][1];
        });
      } else {
        meetingInfo({ id: this.$route.params.id }).then(response => {
          this.historyDetail = response.data;
          this.historyDetail.attendeesLength = response.data.attendees ? `${response.data.attendees.length}人` : '0人';
          this.historyDetail.statesLength = response.data.states ? response.data.states.length : 0; 4;
          let data = '';
          if (response.data.agendas) {
            data = response.data.agendas.join('、');
          } else {
            data = '无';
          }
          this.historyDetail.agendasStr = data;
          this.headName = this.statusMap[response.data.meetingStatus][0];
          this.color = this.statusMap[response.data.meetingStatus][1];
        });
      }
    },
    // 拒绝审核
    refuseCheck() {
      this.showRefuseDialog = true;
    },
    // 提交拒绝审核
    confirmRefuse() {
      const data = {
        id: this.historyDetail.id,
        remark: this.message,
        audit: false
      };
      meetingAudit(data).then(response => {
        this.showRefuseDialog = false;
        if (response.code === 200) {
          this.$toast.success('提交成功');
          setTimeout(() => {
            // location.reload();
            this.getHistoryDetail();
          }, 500);
        } else {
          this.$toast.fail(response.message);
        }
      });
    },
    passCheck() {
      const data = {
        id: this.historyDetail.id,
        remark: '',
        audit: true
      };
      meetingAudit(data).then(response => {
        if (response.code === 200) {
          this.$toast.success('提交成功');
          setTimeout(() => {
            // location.reload();
            this.getHistoryDetail();
          }, 500);
        } else {
          this.$toast.fail(response.message);
        }
      });
    },
    onAttendees() {
      if (this.historyDetail.attendees.length > 0) {
        const data = {
          organizer: [{ attendee: this.historyDetail.organizer, company: this.historyDetail.organization }],
          inners: [...this.historyDetail.inners],
          outers: [...this.historyDetail.outers]
        };
        const list = JSON.stringify(data);
        this.$router.push({ name: 'attendees', query: { list, title: '参会人' }});
      }
    },
    onRequires() {
      if (this.historyDetail.requires.length > 0) {
        const list = JSON.stringify(this.historyDetail.requires);
        this.$router.push({ name: 'requires', query: { list, title: '会务要求' }});
      }
    },
    onCancel() {
      this.showMeetingCancelDialog = true;
    },
    confirmMeetingCancel() {
      const data = {
        id: this.historyDetail.id,
        remake: this.meetingMessageCancel
      };
      meetingCancel(data).then(response => {
        if (response.code === 200) {
          this.$toast.success('取消成功');
          setTimeout(() => {
            // location.reload();
            this.getHistoryDetail();
          }, 500);
        } else {
          this.$toast.fail(response.message);
        }
      });
    },
    onCancelJoin() {
      this.showCancelDialog = true;
    },
    confirmCancel() {
      const data = {
        id: this.historyDetail.id,
        remake: this.messageCancel
      };
      if (!this.weChatEve) {
        const str = this.$route.params.id.split('-');
        meetingAttendeeCancelBrowser({ meetingId: str[0], phone: str[1] }).then(res => {
          this.$toast.success('取消成功');
          setTimeout(() => {
            // location.reload();
            this.getHistoryDetail();
          }, 500);
        });
      } else {
        meetingAttendeeCancel(data).then(res => {
          this.$toast.success('取消成功');
          setTimeout(() => {
            // location.reload();
            this.getHistoryDetail();
          }, 500);
        });
      }
    },
    meetingSignIn() {
      if (!this.weChatEve) {
        const str = this.$route.params.id.split('-');
        meetingSignInBrowser({ meetingId: str[0], phone: str[1] }).then(response => {
          if (response.code === 200) {
            this.$toast.success('签到成功');
            setTimeout(() => {
              // location.reload();
              this.getHistoryDetail();
            }, 500);
          } else {
            this.$toast.fail(response.message);
          }
        });
      } else {
        meetingSignIn({ id: this.$route.params.id }).then(response => {
          if (response.code === 200) {
            this.$toast.success('签到成功');
            setTimeout(() => {
              // location.reload();
              this.getHistoryDetail();
            }, 500);
          } else {
            this.$toast.fail(response.message);
          }
        });
      }
    },
    getCode() {
      this.$router.push({ name: 'historyDetail', query: { id: this.historyDetail.visitorLogId, backId: this.historyDetail.id }});
    },
    onRebook() {
      this.$router.push({ name: 'meetingBook' });
    },
    onCopy(e) {
      const baseURL = process.env.NODE_ENV === 'development' ? config.baseUrl.dev : config.baseUrl.pro;
      const url = baseURL + e;
      const clipboard = new Clipboard('.tag', {
        text: function() {
          return url;
        }
      });
      clipboard.on('success', e => {
        this.$toast({
          message: '复制成功，请在浏览器打开'
        });
        clipboard.destroy();
      });
      clipboard.on('error', e => {
        this.$toast({
          message: '复制失败'
        });
        clipboard.destroy();
      });
    },
    onShare() {
      this.showTips = true;
      const url = window.location.href.split('#');
      wechatSignature({ url: url[0] }).then(res => {
        // 要显示的菜单项，所有menu项见附录3
        // wx.config({
        //   debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        //   appId: res.data.appId, // 必填，公众号的唯一标识
        //   timestamp: res.data.timestamp, // 必填，生成签名的时间戳
        //   nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
        //   signature: res.data.signature, // 必填，签名
        //   jsApiList: ['updateAppMessageShareData', 'showMenuItems'] // 必填，需要使用的JS接口列表
        // });
        this.getShare();
      });
    },
    onCopyShareUrl() {
      const that = this;
      const clipboard = new Clipboard('.url', {
        text: function() {
          return that.inviteUrl;
        }
      });
      clipboard.on('success', e => {
        this.$toast({
          message: '复制成功'
        });
        clipboard.destroy();
      });
      clipboard.on('error', e => {
        this.$toast({
          message: '复制失败'
        });
        clipboard.destroy();
      });
    },
    getShare() {
      meetingShare({ id: this.$route.params.id }).then(res => {
        if (res.data.done) {
          this.inviteUrl = res.data.url;
          wx.showMenuItems({
            menuList: ['menuItem:share:appMessage'] // 要显示的菜单项，所有menu项见附录3
          });
          wx.updateAppMessageShareData({
            title: res.data.title, // 分享标题
            desc: res.data.desc, // 分享描述
            link: res.data.url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: res.data.image, // 分享图标
            success: function() {
              // 设置成功
            }
          });
        }
      });
    }
  }
};
</script>

<style lang="less">
.staffhistoryDetail {
  min-height: 100vh;

  .control {
    .van-field__control{
      text-align: left;
    }
  }

  .van-cell__title {
    -webkit-box-flex: unset;
    -webkit-flex: unset;
    flex: unset;
  }
  padding-bottom: 0.2rem;
  .content {
    padding-bottom: 0.15rem;
    position: relative;
    .inviteWechatShare {
      background-color: #57c55f;
      border-radius: 100%;
      padding: 5px;
    }
    .inviteCopyShare {
      margin-left: 0.02rem;
      background-color: #3b86ff;
      border-radius: 100%;
      padding: 5px;
    }
    .signIn {
      position: absolute;
      top: -10px;
      right: 10px;
      z-index: 19999;
    }
    .content-title,
    .visitStatus {
      height: 0.45rem;
      line-height: 0.45rem;
      padding: 0rem 0.15rem;
    }
    .content-detail,
    .content-reason {
      font-size: 0.17rem;
      color: #333;
      background: #fff;
      padding: 0.18rem 0.15rem;
    }
    .content-detail p:not(:last-child) {
      margin-bottom: 0.1rem;
    }
    .content-reason {
      padding: 0rem 0.15rem;
      .content-reasonItem {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 0.55rem;
        line-height: 0.55rem;
        .faceImg {
          width: 0.33rem;
          height: 0.33rem;
          line-height: 0.33rem;
          .svg-icon {
            width: 100%;
            height: 100%;
          }
          img {
            width: 100%;
            height: 100%;
            border-radius: 50%;
          }
        }
      }
      .content-reasonItem:not(:last-child) {
        border-bottom: 1px solid #e5e5e5;
      }
    }
    .has-small-magb{
      position: relative;
      margin-bottom: 0.1rem;
      .content-reasonItem[class~='has-status']{
        height:0.73rem;
      }
      .tip-status{
        width: 0.65rem;
        height: 0.2rem;
        line-height: 0.2rem;
        text-align: center;
        border-radius: 14px 0px 0px 14px;
        color: #fff;
        font-size: .14rem;
        position: absolute;
        right: 0px;
        &.CANCEL,
        &.UNVISIT,
        &.AUDIT_FAIL,
        &.OUTTIME_AUDIT {
          background-color: rgba(51, 51, 51, 0.5);
        }

        &.WAITING_AUDIT,
        &.WAITING_VERIFY {
          background-color: #f2b230;
        }

        &.OUTTIME_VISIT,
        &.AUDIT_REFUSED {
          background-color: #f76260;
        }

        &.VISITING,
        &.WAITING_VISIT {
          background-color: #3b86ff;
        }

        &.FINISH,
        &.AUDIT_PASSED {
          background-color: #2dcc2c;
        }
      }

    }

    .itemClass {
      background-color: #FFFFFF;
      padding: 0.145rem 0.16rem 0 0.145rem;
      .meetingItem {
        padding-bottom: 0.16rem;
        font-size: 0.16rem;
        color: #333333;
        border-bottom: 1px solid #ebedf0;
      }
    }
  }
  .btns {
    display: flex;
    justify-content: space-between;
    //margin-top: 0.1rem;
    margin-bottom: 0.2rem;
    padding: 0rem 0.28rem;
    > div {
      width: 100%;
      height: 0.47rem;
      font-size: 0.18rem;
      color: #fff;
      line-height: 0.47rem;
      text-align: center;
    }
    div:first-child {
      background: #FFBE00;
      border: 1px solid rgba(5, 5, 5, 0.08235294117647057);
      opacity: 1;
      border-radius: 5px;
    }
    div:last-child {
      background: #2DCC2C;
      border: 1px solid rgba(5, 5, 5, 0.08235294117647057);
      opacity: 1;
      border-radius: 5px;
    }
  }
  //.van-field__control {
  //  text-align: left;
  //}
  .shareBtns {
    display: flex;
    justify-content: space-between;
    margin-top: 0.2rem;
    margin-bottom: 0.3rem;
    padding: 0rem 0.28rem;
    > div {
      width: 100%;
      height: 0.47rem;
      font-size: 0.18rem;
      color: #fff;
      border-radius: 5px;
      line-height: 0.47rem;
      text-align: center;
    }
    div:first-child {
      background: rgba(255, 190, 0, 1);
      border: 2px solid rgba(5, 5, 5, 0.0823);
    }
    div:last-child {
      background: rgba(45, 204, 44, 1);
      border: 2px solid rgba(5, 5, 5, 0.0823);
    }
  }
  .cover {
    position: absolute;
    opacity: 0.5;
    top: 0;
    height: 100%;
    width: 100%;
    background-color: black;
    .share {
      position: absolute;
      right: 20px;
      top: 10px;
      width: 2rem;
      height: 2rem;
    }
    .shareBtn {
      position: absolute;
      right: 0;
      top: 0;
      left: 0;
      bottom: 0;
      margin: auto;
      width: 2rem;
      height: 2rem;
    }
  }

  .van-overlay {
    z-index: 19999;
  }

}
.content-detail:not(:last-child) {
  border-bottom: 1px solid rgba(229, 229, 229, 1);
}
.stall_tip{
  padding: 0 0.15rem;
  font-size: 0.14rem;
  color: #888;
  margin-top: 0.1rem;
}

</style>
